import React from "react";
import { usePlanningSettings } from "../hooks/usePlanningSettings";

/**
 * Higher-Order Component that provides planning settings to class components
 * @param {Component} WrappedComponent - The component to wrap
 * @param {Function} getOutletId - A function that extracts the outletId from props and state
 * @returns {Component} - The wrapped component with planning settings
 */
export function withPlanningSettings(WrappedComponent, getOutletId) {
    return function WithPlanningSettingsWrapper(props) {
        // We need a way to get the outletId from the wrapped component
        // This will be handled by passing it as a prop or using a ref
        const [outletId, setOutletId] = React.useState(null);
        
        const { canUseAgendasAndAbsencesInSettings, isLoading, refetchSettings } = usePlanningSettings(outletId);

        return (
            <WrappedComponent
                {...props}
                canUseAgendasAndAbsencesInSettings={canUseAgendasAndAbsencesInSettings}
                planningSettingsLoading={isLoading}
                onOutletChangeForSettings={setOutletId}
                refetchPlanningSettings={refetchSettings}
            />
        );
    };
}
